import { render, staticRenderFns } from "./ProjectEditLinkedData.vue?vue&type=template&id=83526338&"
import script from "./ProjectEditLinkedData.vue?vue&type=script&lang=js&"
export * from "./ProjectEditLinkedData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports